<div id="tour" class="mt-5 mb-3">
    <div class="container">
        <div class="row">
            <div class="col-12 text-center">
                <h2 class="home-title">Aryakulam International School Campus Tour</h2>
                <p class="mb-2">Our Aryakulam International School tour takes you around campus and into Academic
                    Buildings,
                    Administrative Offices, Schools, Hostels, Health Care and Other Amenities in Campus.</p>
                <div id="tour-content">
                    <img src="/assets/img/tour/1.jpg" alt="Tour" class="w-100 rounded-5">
                    <i class="fa-solid fa-circle-play" data-bs-toggle="modal" data-bs-target="#tourModal" (click)="openVideo()"></i>
                </div>
                <!-- <a class="btn py-3 mt-3 shadow" href="https://youtube.com/shorts/CXfu5jtj6gw?si=PMsF7EKqTvXDtTTP"
                    target="_blank">More On Campus Tour <i class="fa-solid fa-arrow-right"></i></a> -->
            </div>
        </div>
    </div>
</div>
<div class="modal fade" id="tourModal" tabindex="-1" aria-hidden="true">
    <div class="modal-dialog modal-dialog-centered modal-lg custom-tour-modal">
        <div class="modal-content glass-cinema-content">
            <div class="modal-header border-0 pb-2">
                <h2 class="modal-title-custom mb-0">Campus Tour</h2>
                <button type="button" class="btn-close-custom" data-bs-dismiss="modal" aria-label="Close">
                    <i class="fa-solid fa-xmark"></i>
                </button>
            </div>
            <div class="modal-body">
                <div class="video-screen-wrapper">
                    <iframe *ngIf="isVideoActive" width="100%" height="480" src="https://drive.google.com/file/d/1l9cjuWAC13-udKrpScIiO0JTwEjIIrc2/preview" frameborder="0"
                        allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture"
                        allowfullscreen>
                    </iframe>
                </div>
            </div>
        </div>
    </div>
</div>